import Modal, { ModalBody, ModalFooter } from "@components/ui/Modal";
import Button from "@components/ui/Button";

export default function ViewTextModal({ open, title, text, onClose }) {
  return (
    <Modal show={open} onClose={onClose} title={title} size="lg">
      <ModalBody>
        <div className="whitespace-pre-wrap break-words text-sm text-gray-700 max-h-[60vh] overflow-y-auto font-mono">
          {text || "—"}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex justify-end">
          <Button color="light" onClick={onClose}>
            Close
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
